import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    departments: [],
    designations: [],
    sections: [],
    subjects: [],
    roles: [],
    classes: [],
    users: [],
    leave_types: [],
    import_subjects: [],
    import_classes: [],
    sessions: [],
};

const basicSetupSlice = createSlice({
    name: "basicSetup",
    initialState,
    reducers: {
        _setImportClasses: (state, action) => {
            state.import_classes = action.payload;
        },
        _setImportSubjects: (state, action) => {
            state.import_subjects = action.payload;
        },
        _setDepartment: (state, action) => {
            state.departments = action.payload;
        },
        _setDesignation: (state, action) => {
            state.designations = action.payload;
        },
        // Note: _setSections and _setSubjects removed as they're school management related
        _setRoles: (state, action) => {
            state.roles = action.payload;
        },
        _setClasses: (state, action) => {
            state.classes = action.payload;
        },
        _setUsers: (state, action) => {
            state.users = action.payload;
        },
        _updateDepartment: (state, action) => {
            state.departments.push(action.payload);  // Append new department
        },
        _updateDesignation: (state, action) => {
            state.designations.push(action.payload);  // Append new designation
        },
        // Note: _updateSubjects and _updateSections removed as they're school management related
        _setLeaveTypes: (state, action) => {
            state.leave_types = action.payload;
        },
        _setClassLoading: (state, action) => {
            state.class_loading = action.payload;
        },
        _setSessions: (state, action) => {
            state.sessions = action.payload;
        },
        _addSession: (state, action) => {
            state.sessions.push(action.payload);
        },
        _updateSession: (state, action) => {
            const index = state.sessions.findIndex(session => session.uuid === action.payload.uuid);
            if (index !== -1) {
                state.sessions[index] = action.payload;
            }
        },
        _removeSession: (state, action) => {
            state.sessions = state.sessions.filter(session => session.uuid !== action.payload);
        }
    },
});

export const {
    _setImportClasses,
    _setImportSubjects,
    _setDepartment,
    _setDesignation,
    _setClasses,
    _setRoles,
    _setUsers,
    _updateDepartment,
    _updateDesignation,
    _setLeaveTypes,
    _setClassLoading,
    _setSessions,
    _addSession,
    _updateSession,
    _removeSession
} = basicSetupSlice.actions;

export default basicSetupSlice.reducer;
